import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faTrashAlt,
} from '@fortawesome/free-solid-svg-icons';

const customStyles = {
  rows: {
    style: {
      minHeight: '72px', // override the row height
    }
  },
  headCells: {
    style: {
      paddingLeft: '8px', // override the cell padding for head cells
      paddingRight: '8px',
    },
  },
  cells: {
    style: {
      paddingLeft: '8px', // override the cell padding for data cells
      paddingRight: '8px',
    },
  },
};

const columns = (prefijo, showPrefixGuide) => {
 return [
    {
      grow: 0,
      name: 'Guia',
      selector: 'guia_paquete',
      sortable: true,
      cell: row => (
        `${showPrefixGuide ? row.master_guia.rel_tipos.prefijo : prefijo}-${row.guia_paquete}`
      ),
    },
    {
      name: 'Cliente',
      cell: row => (
        <div className="d-flex flex-column">
          <div style={{ fontSize: 11, fontWeight: 'bold' }}>{row.cliente.rut}</div>
          <div>{row.cliente.name}</div>
        </div>
      )
    }
  ];
}

const columnsDestino = (prefijo, callBackRemove) => {
  return [
     {
       name: 'Guia',
       selector: 'guia_paquete',
       sortable: true,
       cell: row => (
         `${prefijo}-${row.guia_paquete}`
       ),
     },
     {
      name: 'Regresar',
      cell: row => (
        <button onClick={() => callBackRemove(row)} className="btnx btnx-warn icon-table">
          <FontAwesomeIcon icon={faTrashAlt} />
        </button>
      ),
      grow: 0,
      align: 'right',
    },
   ];
 }

const table = {
  columns,
  columnsDestino,
  customStyles,
}

export default table;